import { createUseStyles } from 'react-jss';
export default createUseStyles({
    container: {
        height: '93px',
        width: '75px',
        borderRadius: 10,
        color: '#BBB8B8',
        padding: '8px 4px 10px 4px',
        alignItems: 'center'
    },
    grow: { flexGrow: 1 },
});
//# sourceMappingURL=styles.js.map